import React from "react";
import { Box, Typography, SvgIcon } from "@mui/material";
import { styled, keyframes } from "@mui/system";

// Keyframes for rotation animation
const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

// Styled Loader Container
const LoaderContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
});

// Styled Icon with Animation
const RotatingIcon = styled(SvgIcon)({
  height: "1.5rem",
  width: "1.5rem",
  animation: `${spin} 1s linear infinite`,
  stroke: "rgba(107, 114, 128, 1)",
});

// Styled Text
const LoadingText = styled(Typography)({
  fontSize: "0.75rem",
  fontWeight: 500,
  color: "rgba(107, 114, 128, 1)",
  marginLeft: "8px",
});

const RotatingLoader = () => {
  return (
    <LoaderContainer role="status" aria-label="Loading...">
      <RotatingIcon viewBox="0 0 256 256">
        <line
          x1="128"
          y1="32"
          x2="128"
          y2="64"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="24"
        />
        <line
          x1="195.9"
          y1="60.1"
          x2="173.3"
          y2="82.7"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="24"
        />
        <line
          x1="224"
          y1="128"
          x2="192"
          y2="128"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="24"
        />
        <line
          x1="195.9"
          y1="195.9"
          x2="173.3"
          y2="173.3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="24"
        />
        <line
          x1="128"
          y1="224"
          x2="128"
          y2="192"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="24"
        />
        <line
          x1="60.1"
          y1="195.9"
          x2="82.7"
          y2="173.3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="24"
        />
        <line
          x1="32"
          y1="128"
          x2="64"
          y2="128"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="24"
        />
        <line
          x1="60.1"
          y1="60.1"
          x2="82.7"
          y2="82.7"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="24"
        />
      </RotatingIcon>
      <LoadingText> Please wait till we get the insights ready!</LoadingText>
    </LoaderContainer>
  );
};

export default RotatingLoader;
